import React from "react";
import { ErrorBoundaryContext } from "./error-boundary-context";
import { usePageErrorBoundaryHook } from "./error-boundary-hooks";

export function PageContextErrorBoundaryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageErrorBoundaryHook();

  return (
    <ErrorBoundaryContext.Provider value={value}>
      {children}
    </ErrorBoundaryContext.Provider>
  );
}
